import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, HourglassIcon } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { EmptyState } from '@epi-shared/components/EmptyState';
import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';

export const AnotherUploadInProgress = ({
  hasEmployees
}: {
  hasEmployees?: boolean;
}) => {
  const reduxDispatch = useDispatch();
  const { t } = useTranslation();
  const { warningColorLight, warningColor } = useTheme();

  return (
    <Box
      bgcolor={warningColorLight}
      border={`1px solid ${warningColor}`}
      borderRadius={1}
      pt={2.5}
      pb={8}
      px={24}
      mt={6}
    >
      <EmptyState
        icon={<HourglassIcon />}
        title={
          hasEmployees
            ? t(
                'containers.beneficiaries.import_employees.in_progress_error.title'
              )
            : t('employees.import_in_progress_title')
        }
        description={
          hasEmployees
            ? t(
                'containers.beneficiaries.import_employees.in_progress_error.description'
              )
            : t('employees.import_in_progress_description')
        }
        btnText={
          (hasEmployees &&
            t(
              'containers.beneficiaries.import_employees.in_progress_error.button'
            )) ||
          undefined
        }
        btnOnClick={
          hasEmployees
            ? () => reduxDispatch(goToPage(routerPaths.beneficiaries))
            : undefined
        }
      />
    </Box>
  );
};
